import { makeObservable, observable } from 'mobx';

/* You keep the state between login, signup & forgot password forms */
export class SharedFormState {
  @observable.ref
  firstName = '';

  @observable.ref
  lastName = '';

  @observable.ref
  email = '';

  @observable.ref
  password = '';

  constructor() {
    makeObservable(this);
  }
}
